/**
 * Tarifs à l'acte — source de vérité du front.
 *
 * Les montants doivent refléter CE QUE STRIPE FACTURE, pas une intention :
 *   · certified_mail  → pas de checkout côté serveur à ce jour ; montant
 *                      indicatif, front uniquement.
 *
 * Le libellé affiché n'est plus écrit à la main : il est calculé par
 * `formatPrice`, sinon un montant et son libellé finissent par diverger —
 * c'est exactement ce qui était arrivé (catalogue « 49,99€ » pour une
 * lettre facturée 39 €, et « $149 » affiché à des clients belges).
 *
 * `live_counsel` a été retiré du catalogue : Archer ne facture pas les
 * honoraires d'avocat. L'avocat partenaire est externe, il offre la
 * première consultation puis facture ses honoraires en direct, hors
 * Archer. Il n'y a donc plus de tarif Archer pour une visio — pas de
 * montant à afficher, pas de montant à zéro non plus.
 */

const NBSP = ' ';

/**
 * Format monétaire par juridiction.
 *   BE → « 149 € », « 49,99 € »  (virgule décimale, espace insécable
 *        avant le symbole : la convention belge/française)
 *   US → « $149 », « $49.99 »
 * Les décimales ne s'affichent que si le montant en a réellement.
 */
export function formatPrice(amount, jurisdiction = 'BE') {
  const num = Number(amount);
  if (!Number.isFinite(num)) return '';
  const hasDecimals = Math.abs(num) % 1 !== 0;
  const isUS = jurisdiction === 'US';
  const formatted = new Intl.NumberFormat(isUS ? 'en-US' : 'fr-BE', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(num);
  return isUS ? `$${formatted}` : `${formatted}${NBSP}€`;
}

// Le recommandé électronique vaut 9,99 € partout (constants/plans.js
// `OVERAGE_EUR.registeredMail`) : un 15 € ici était un reste de grille.
const AMOUNTS = {
  US: { certified_mail: 14 },
  BE: { certified_mail: 9.99 },
};

function build(jurisdiction) {
  const currency = jurisdiction === 'US' ? '$' : '€';
  return Object.entries(AMOUNTS[jurisdiction]).reduce((acc, [key, amount]) => {
    acc[key] = { amount, currency, display: formatPrice(amount, jurisdiction) };
    return acc;
  }, {});
}

export const PRICING = {
  US: build('US'),
  BE: build('BE'),
};

/** Tarif d'un service pour une juridiction, avec repli sur la Belgique
 *  (le produit est belge ; les États-Unis sont gelés jusqu'à M6). */
export function priceOf(service, jurisdiction = 'BE') {
  const table = PRICING[jurisdiction] || PRICING.BE;
  return table[service] || PRICING.BE[service];
}

export const JURISDICTION_LABELS = {
  US: { en: "United States", fr: "États-Unis", es: "Estados Unidos", nl: "Verenigde Staten" },
  BE: { en: "Belgium", fr: "Belgique", es: "Bélgica", nl: "België" },
};

export const DATE_FORMATS = {
  US: "mm/dd/yyyy",
  BE: "dd/mm/yyyy",
};
